module.exports = __webpack_public_path__ + "img/74.4d9f07d4.jpg";